import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  AccessCodeAndClientSecret,
  AuthFormNotificationType,
  AuthFormType,
} from '@shared/models/auth.interface';
import { AppService, LoadingService } from '@shared/services/core';
import { AuthService } from '@shared/services/auth/auth.service';
import { BehaviorSubject} from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { SnackbarService } from '@shared/services/core/snackbar.service';

@Component({
  selector: 'app-other-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  @Output() notify = new EventEmitter<AuthFormNotificationType>();
  @Output() result = new EventEmitter<
    { code: string; logo: string } | undefined
  >();
  notClosed: boolean = false;
  notificationShown: boolean = false;
  notificationType: AuthFormNotificationType = 'ACCESSCODE_ERROR';
  currentForm: AuthFormType = 'ACCESSCODE';
  lastForm$ = new BehaviorSubject<AuthFormType>('ACCESSCODE');
  readonly defaultLogo: string = '/assets/images/entireonhire-logo.svg';
  userLogo: string = this.defaultLogo;
  accessCode: string = '';
  companyCode: string | undefined;

  private _qurParam: string = '';

  constructor(
    private loadingService: LoadingService,
    private appService: AppService,
    private authService: AuthService,
    private _activeRoute: ActivatedRoute,
    private snackbarService: SnackbarService
  ) {
    this.loadingService.showLoading();
  }

  ngOnInit(): void {
    this._qurParam = this._activeRoute.snapshot.queryParams['se'];
    this.companyCode = this._activeRoute.snapshot.queryParams['ac'];
    this.loadingService.stopLoading();
    this.clearBackButtonHistory();

    let authStatusType = this._activeRoute.snapshot.queryParams['authStatus'];
    if (authStatusType) {
      this.showNotificationFor(authStatusType);
    }

    if (this._qurParam) {
      this.snackbarService.showErrorSnackBar(
        'Session Expired',
        'We apologize for the inconvenience, but your session has ended. Please log in again.',
        ''
      );
    }
    if (this.companyCode) {
      this.proceedForLogin();
    }
  }

  closeMessageBox() {
    this.notClosed = false;
  }

  toggleToForm(form: AuthFormType) {
    this.notificationShown = false;
    this.lastForm$.next(this.currentForm); // for animation.
    this.currentForm = form;
  }

  toggleToPreviousForm() {
    this.notificationShown = false;
    this.lastForm$.next(this.currentForm); // for animation.

    if (this.currentForm === 'LOGIN') {
      this.accessCode = '';
      this.userLogo = this.defaultLogo;
      this.currentForm = 'ACCESSCODE';
    } else {
      this.currentForm = 'LOGIN';
    }
  }

  updateData(data?: { code: string; logo: string }) {
    this.userLogo = data?.logo ?? this.defaultLogo;
    this.accessCode = data?.code || '';
    if (this.notificationShown) this.notificationShown = false;
    this.lastForm$.next('ACCESSCODE');
    this.currentForm = 'LOGIN';
  }

  showNotificationFor(notificationType: AuthFormNotificationType | null) {
    if (notificationType === null) this.notificationShown = false;
    else {
      this.notificationType = notificationType;
      this.notificationShown = true;
    }
  }

  clearBackButtonHistory() {
    history.pushState(null, document.title, location.href);
    window.addEventListener('popstate', function () {
      history.pushState(null, document.title, location.href);
    });
  }

  proceedForLogin() {
    const requestBody: AccessCodeAndClientSecret = {
      code: this.companyCode!,
      clientId: this.appService.getAppSettings().apiCredentials.clientID,
      clientSecret:
        this.appService.getAppSettings().apiCredentials.clientSecret,
    };
    this.loadingService.showLoading();
    this.authService
      .checkAccessToken(requestBody)
      .pipe()
      .subscribe({
        next: (response) => {
          if (response && response.data) {
            this.accessCode=this.companyCode||"";
            this.userLogo=`data:image/jpg;base64, ${response.data.clientLogo}`
            this.toggleToForm('LOGIN')
            // this.result.next({
            //   code: requestBody.code,
            //   logo: `data:image/jpg;base64, ${response.data.clientLogo}`,
            // });
          }
          this.loadingService.stopLoading();
        },
        error: (err: Error) => {
          if (err.message === 'Unauthorized') {
            this.showNotificationFor('ACCESS_DENIED');
          } else this.showNotificationFor('ACCESSCODE_ERROR');
          this.loadingService.stopLoading();
        },
      });
  }
}
